import { atom, useRecoilState } from "recoil";

interface BuildingsPageState {
    view: PortfolioPageView;
}

const buildingsPageStateAtom = atom<BuildingsPageState>({
    key: "portfolioPageState",
    default: {
        view: "table",
    },
});

const useBuildingsPageState = () => {
    const [pageState, setPageState] = useRecoilState(buildingsPageStateAtom);

    return {
        pageState,
        setPageState,
    };
};

export default useBuildingsPageState;
